// Contact Configuration
export const CONTACT_INFO = {
  PHONE: '7903555288',
  EMAIL: 'support@themaithil.com',
  WHATSAPP: '917903555288', // Without +, just country code and number
  ADDRESS: 'Mumbai, Maharashtra, India',
  COMPANY_NAME: 'The Maithil',
  
  // WhatsApp Messages
  WHATSAPP_MESSAGES: {
    BOOKING: 'Hi! I would like to book your service.',
    INQUIRY: 'Hi! I have a question about your services.',
    SUPPORT: 'Hi! I need support regarding my booking.'
  }
};

// Social Links
export const SOCIAL_LINKS = [
  { name: 'Facebook', url: 'https://facebook.com' },
  { name: 'X', url: 'https://x.com' },
  { name: 'Instagram', url: 'https://instagram.com' },
  { name: 'YouTube', url: 'https://youtube.com' },
  { name: 'LinkedIn', url: 'https://linkedin.com' },
  { name: 'WhatsApp', url: `https://wa.me/${CONTACT_INFO.WHATSAPP}` }
];

// Helper function to generate WhatsApp URL
export const getWhatsAppURL = (message = '') => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${CONTACT_INFO.WHATSAPP}?text=${encodedMessage}`;
};

// Helper function to generate WhatsApp link for booking
export const getWhatsAppBookingLink = (serviceName = '', phone = '', email = '') => {
  let message = `Hi! I would like to book your service`;
  if (serviceName) {
    message += ` - ${serviceName}`;
  }
  if (phone || email) {
    message += '. My contact details: ';
    if (phone) message += `Phone: ${phone}`;
    if (email) message += `${phone ? ', ' : ''}Email: ${email}`;
  }
  return getWhatsAppURL(message);
};
